module.exports = __webpack_public_path__ + "static/media/enokistudiologo.6e15fb91.svg";